import { type WarehouseLocation, PickingLabor, FulfillmentMethod } from 'legacy/common/types'

// This check duplicates the backend check:
// https://github.com/instacart/carrot/blob/182ddb34abd43e1e86abf9095a251905f26a42c7/partners/retailers/app/models/resources/warehouse_location.rb#L34
export const filterPickupWarehouseLocations = ({
  pickingLabor,
  fulfillmentMethods,
  configValues,
  partnerAlcoholDelivery,
}: WarehouseLocation) =>
  pickingLabor === PickingLabor.Retailer ||
  fulfillmentMethods.includes(FulfillmentMethod.Retailer) ||
  configValues.hybridPickingEnabled ||
  partnerAlcoholDelivery
